import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  initializeIcons() {
    const icons = [
      'box',
      'bell',
      'info',
      'question-mark',
      'settings',
      'sign-out',
      'user',
      'hamburger',
      'refresh',
      'page-1',
      'group-7',
      'group-plus',
      'group-11',
      'group-14',
      'group-16',
      'history-clock-button',
      'collect',
      'arrow-back',
      'delete',
      'fill-1',
      'wifi-on',
      'wifi-off',
      'create',
      'logout-confirmation',
      'minus',
      'medicine_2',
      'view',
      'keyboard',
      'pharmacy',
      'in-recovery',
      'in-theatre',
      'patient-icon',
      'waiting',
      'cancel',
      'delete-icon',
      'in-ward-icon',
      'timer-stop',
      'timer-start',
      'cancel-blank',
      'devices',
      'people',
      'inbox',
      'done',
      'search',
      'home',
      'theatre',
      'patient-summary',
      'reporting',
      'whiteboard',
      'basket',
      'discharged-patients',
      'materials',
      'services',
      'delete-outline',
      'remove',
      'services-letter',
      'done-one',
      'clear',
      'check',
      'barcode',
      'pack',
      'expand-more',
      'expand-less',
      'add-remaining',
      'add',
      'pack-pill',
      'hospital-bed',
      'patient-transfer',
      'patient-transfer-white',
      'patien-discharge',
      'patien-discharge-white',
      'material-transfer',
      'material-transfer-white',
      'emergency-cupboard',
      'pencil',
      'list',
      'calculator',
      'recovery',
      'operating-room',
      'close-line',
      'arrow-forward',
      'password-lock',
      'training',
      'training-dark',
      'pending-circle',
      'test',
      'check-circle',
      'cross-circle',
      'delete-history',
      'stack',
      'user-tie',
      'file-text2',
      'drawer',
      'config',
      'csv',
      'filter',
      'filter-remove',
      'print',
      'upload',
      'complete',
      'up-arrow',
      'down-arrow',
      'red-exclamation-mark',
      'messageNone',
      'checklist-patient',
      'checklist-doctor',
      'checklist-syringe',
      'checklist-edit',
      'checklist-add',
      'checklist-delete',
      'complete-checklist',
      'chevron-right'
    ];
    icons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `../../../assets/img/${icon}.svg`
        )
      );
    });
  }
}
